export const WEEK_DAYS: DayOfWeek[] = [
  { id: 'Monday', label: 'Пн' },
  { id: 'Tuesday', label: 'Вт' },
  { id: 'Wednesday', label: 'Ср' },
  { id: 'Thursday', label: 'Чт' },
  { id: 'Friday', label: 'Пт' },
  { id: 'Saturday', label: 'Сб' },
  { id: 'Sunday', label: 'Нд' },
];

export interface DayOfWeek {
  id: string;
  label: string;
}

export const HOURS_STRINGS_ARRAY: string[] = [
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
];

export function sortDays(days: string[]): string[] {
  const DAY_ORDER = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

  days.sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b));
  return days;
}
